import React, { useState, lazy } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { CallbackModal } from '../components/CallbackModal';
import { MapPin, Star, Scan, Languages, Calendar, MessageCircle, Phone, CheckCircle2, ArrowRight, Plus, Minus, Microscope, ShieldCheck, CreditCard, Heart, Users, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
const TELEGRAM_URL = 'https://t.me/dentico_clinic';
const MAPS_URL = 'https://maps.app.goo.gl/Fhof2j1jnLA3ffqT6';
const MAPS_EMBED_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1241.0181846982155!2d-0.104187760804084!3d51.53089276153758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760f7c6534e077%3A0xa54a590bd3b2a149!2sDentico%20Clinic%20-%20Private%20Dentist%20in%20Angel%2C%20Islington!5e0!3m2!1suk!2suk!4v1769722166469!5m2!1suk!2suk';
function TelegramIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-3432">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-3433" />
    </svg>;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onToggle
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <div className="border-b border-gray-100 last:border-b-0" data-id="element-3434">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-4 text-left focus:outline-none group" data-id="element-3435">
        <span className="text-lg font-medium text-gray-900 group-hover:text-teal-600 transition-colors" data-id="element-3436">
          {question}
        </span>
        <span className={`flex-shrink-0 ml-4 w-6 h-6 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-teal-600 text-white' : 'bg-gray-100 text-gray-400'}`} data-id="element-3437">
          {isOpen ? <Minus className="w-4 h-4" data-id="element-3438" /> : <Plus className="w-4 h-4" data-id="element-3439" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-3440">
        <p className="text-gray-600 leading-relaxed" data-id="element-3441">{answer}</p>
      </div>
    </div>;
}
export function UkrainianDentistPage() {
  const [isCallbackOpen, setIsCallbackOpen] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };
  const services = [{
    id: 'fillings',
    title: 'Пломбування зубів',
    desc: 'Естетичні фотополімерні пломби, що виглядають природно.',
    icon: Microscope
  }, {
    id: 'root-canal',
    title: 'Лікування каналів',
    desc: 'Безболісне лікування під мікроскопом для збереження зуба.',
    icon: Scan
  }, {
    id: 'crowns',
    title: 'Коронки та протезування',
    desc: 'Керамічні коронки та мости для відновлення функції.',
    icon: ShieldCheck
  }, {
    id: 'hygiene',
    title: 'Професійна гігієна',
    desc: "Чистка Airflow та ультразвук для здоров', я, ясен, .",
    icon: Star
  }, {
    id: 'whitening',
    title: 'Відбілювання зубів',
    desc: 'Безпечне освітлення емалі на кілька тонів.',
    icon: Star
  }, {
    id: 'extraction',
    title: 'Видалення зубів',
    desc: 'Атравматичне видалення, включаючи зуби мудрості.',
    icon: ShieldCheck
  }, {
    id: 'smile-makeover',
    title: 'Smile Makeover',
    desc: 'Комплексна естетична трансформація посмішки.',
    icon: Star
  }, {
    id: 'cosmetic',
    title: "Ін'єкційна косметологія",
    desc: 'Естетичні процедури для гармонії обличчя.',
    icon: Star
  }];
  const faqs = [{
    q: 'Чи є український стоматолог у Лондоні?',
    a: 'Так. У Dentico Clinic ви можете отримати консультацію та лікування українською мовою в центрі Лондона — район Angel / Islington (EC1V).'
  }, {
    q: 'Де знаходиться Dentico Clinic?',
    a: 'Наша адреса: 360–364 City Road, London EC1V 2PY. Клініка розташована поруч з Angel Station (Islington).'
  }, {
    q: 'Як записатися на прийом у Dentico Clinic?',
    a: "Ви можете записатися онлайн через сайт або зв'язатися з нами через WhatsApp/Telegram. Також доступний запис телефоном: +44 7345 197820."
  }, {
    q: 'Які послуги надає ваша стоматологія в Лондоні?',
    a: 'Dentico Clinic надає повний спектр стоматологічних послуг: консультації, професійна гігієна, лікування карієсу, лікування каналів, коронки, вініри, імплантація та невідкладна допомога.'
  }, {
    q: 'Чи приймаєте ви пацієнтів з інших районів Лондона?',
    a: "Так. До нас зручно дістатися з Islington, King's Cross, Old Street, Shoreditch та Central London."
  }, {
    q: 'Чи можна отримати консультацію українською мовою?',
    a: 'Так, у Dentico Clinic можливе спілкування українською мовою під час консультації та лікування.'
  }, {
    q: 'Чи робите ви термінові візити при гострому болю?',
    a: "Так. Якщо у вас сильний біль або гострий стан, зв'яжіться з нами якнайшвидше — ми постараємося знайти найближчий доступний час для невідкладної допомоги."
  }, {
    q: 'Що шукати в Google, щоб знайти вашу клініку?',
    a: 'Спробуйте запити: "український стоматолог Лондон", "українська стоматологія Лондон", "Ukrainian dentist London", "dentist near Angel station". Також можна шукати "Dentico Clinic Angel".'
  }];
  // FAQPage structured data for SEO
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a
      }
    }))
  };
  return <Layout data-id="element-3442">
      <CallbackModal isOpen={isCallbackOpen} onClose={() => setIsCallbackOpen(false)} data-id="element-3443" />

      {/* FAQ Structured Data */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} data-id="element-3444" />

      {/* 1. HERO SECTION */}
      <section className="relative bg-white overflow-hidden" data-id="element-3445">
        <div className="absolute inset-0 bg-teal-50/50 -skew-y-3 origin-top-left transform translate-y-20" data-id="element-3446" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-16 lg:pt-20 lg:pb-24 relative" data-id="element-3447">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-3448">
            <div className="space-y-6" data-id="element-3449">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-100 text-teal-800 text-sm font-medium" data-id="element-3450">
                <span className="relative flex h-2 w-2" data-id="element-3451">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-75" data-id="element-3452"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-teal-500" data-id="element-3453"></span>
                </span>
                Український стоматолог у Лондоні
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight tracking-tight" data-id="element-3454">
                Український стоматолог у Лондоні –{' '}
                <span className="text-teal-600" data-id="element-3455">Dentico Clinic</span>
                <br data-id="element-3456" />
                <span className="text-2xl sm:text-3xl font-medium text-gray-500 mt-2 block" data-id="element-3457">
                  (Angel, Islington)
                </span>
              </h1>

              <p className="text-lg text-gray-600 max-w-lg leading-relaxed" data-id="element-3458">
                Сучасна цифрова стоматологія в центрі Лондона з консультацією
                українською мовою. Angel Station, EC1V 2PY.
              </p>

              {/* Trust Badges Row */}
              <div className="flex flex-wrap gap-3 text-sm font-medium text-gray-700" data-id="element-3459">
                <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-lg border border-gray-200 shadow-sm" data-id="element-3460">
                  <Star className="w-4 h-4 text-yellow-400 fill-current" data-id="element-3461" />
                  5★ Google Reviews
                </div>
                <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-lg border border-gray-200 shadow-sm" data-id="element-3462">
                  <MapPin className="w-4 h-4 text-teal-600" data-id="element-3463" />
                  Central London, Angel
                </div>
                <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-lg border border-gray-200 shadow-sm" data-id="element-3464">
                  <Scan className="w-4 h-4 text-teal-600" data-id="element-3465" />
                  Цифрова стоматологія
                </div>
                <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-lg border border-gray-200 shadow-sm" data-id="element-3466">
                  <Languages className="w-4 h-4 text-teal-600" data-id="element-3467" />
                  Українська мова
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 pt-4" data-id="element-3468">
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-3469">
                  <Button size="lg" className="w-full gap-2 shadow-lg shadow-teal-600/20" data-id="element-3470">
                    <Calendar className="w-5 h-5" data-id="element-3471" />
                    Записатись онлайн
                  </Button>
                </a>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-3472">
                  <Button variant="outline" size="lg" className="w-full gap-2 border-teal-200 text-teal-700 hover:bg-teal-50" data-id="element-3473">
                    <MessageCircle className="w-5 h-5 text-green-600" data-id="element-3474" />
                    WhatsApp
                  </Button>
                </a>
                <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-3475">
                  <Button variant="outline" size="lg" className="w-full gap-2 border-teal-200 text-teal-700 hover:bg-teal-50" data-id="element-3476">
                    <TelegramIcon className="w-5 h-5 text-blue-500" data-id="element-3477" />
                    Telegram
                  </Button>
                </a>
              </div>
            </div>

            <div className="relative" data-id="element-3478">
              <div className="absolute inset-0 bg-teal-200 rounded-3xl transform rotate-3 blur-sm opacity-30" data-id="element-3479"></div>
              <img src="https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&w=1200&q=80" alt="Український стоматолог у Лондоні - Dentico Clinic" className="relative rounded-3xl shadow-2xl object-cover h-[300px] sm:h-[400px] lg:h-[500px] w-full" data-id="element-3480" />
            </div>
          </div>
        </div>
      </section>

      {/* 2. WHO WE ARE */}
      <section className="py-16 bg-white" data-id="element-3481">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3482">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-3483">
            Хто ми — Dentico Clinic
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-3484">
            Dentico Clinic — це сучасна приватна стоматологічна клініка в районі
            Angel (Central London), де українські пацієнти можуть отримати
            лікування рідною мовою. Ми поєднуємо британські стандарти якості,
            передове цифрове обладнання та щиру турботу про кожного пацієнта.
            Наші лікарі зареєстровані в GDC (General Dental Council) та мають
            багаторічний досвід роботи у Великобританії.
          </p>
          <div className="grid sm:grid-cols-3 gap-6 text-left" data-id="element-3485">
            <div className="bg-gray-50 p-5 rounded-xl border border-gray-100" data-id="element-3486">
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-3487">
                Сучасне обладнання
              </h3>
              <p className="text-sm text-gray-600" data-id="element-3488">
                Цифрові сканери, мікроскопи та 3D-діагностика для точного
                лікування.
              </p>
            </div>
            <div className="bg-gray-50 p-5 rounded-xl border border-gray-100" data-id="element-3489">
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-3490">
                Досвідчені лікарі
              </h3>
              <p className="text-sm text-gray-600" data-id="element-3491">
                Кваліфіковані спеціалісти з досвідом роботи в приватній практиці
                Лондона.
              </p>
            </div>
            <div className="bg-gray-50 p-5 rounded-xl border border-gray-100" data-id="element-3492">
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-3493">Прозорі ціни</h3>
              <p className="text-sm text-gray-600" data-id="element-3494">
                Чесна вартість лікування без прихованих платежів. Прайс
                доступний онлайн.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. WHY UKRAINIANS CHOOSE US */}
      <section className="py-16 bg-gray-50" data-id="element-3495">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3496">
          <div className="text-center mb-12" data-id="element-3497">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-3498">
              Чому українці обирають Dentico Clinic
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-3499">
              Ми розуміємо важливість спілкування рідною мовою, особливо коли
              йдеться про здоров'я.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3500">
            {[{
            icon: Languages,
            title: 'Українська мова',
            desc: "Вам не потрібно хвилюватися про мовний бар'єр. Ми пояснимо все зрозуміло."
          }, {
            icon: Microscope,
            title: 'Сучасне обладнання',
            desc: 'Лікування під мікроскопом та цифрові відбитки без дискомфорту.'
          }, {
            icon: CreditCard,
            title: 'Прозорі ціни',
            desc: 'Ви завжди знаєте вартість лікування до його початку.'
          }, {
            icon: MapPin,
            title: 'Зручне розташування',
            desc: 'Всього 5 хвилин від станції Angel (Northern Line), Central London.'
          }, {
            icon: Calendar,
            title: 'Онлайн-запис',
            desc: 'Зручна система бронювання 24/7 без дзвінків.'
          }, {
            icon: ShieldCheck,
            title: 'Досвідчені лікарі',
            desc: 'Високі стандарти стерилізації та безпеки (HTM 01-05).'
          }].map((item, idx) => <Card key={idx} className="p-6 hover:shadow-md transition-shadow" data-id="element-3501">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center text-teal-600 mb-4" data-id="element-3502">
                  <item.icon className="w-6 h-6" data-id="element-3503" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-3504">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-3505">{item.desc}</p>
              </Card>)}
          </div>
        </div>
      </section>

      {/* 3.5 COMMUNITY HUB SECTION (NEW) */}
      <section className="py-16 bg-white border-t border-gray-100" data-id="element-3506">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3507">
          <div className="text-center mb-12" data-id="element-3508">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-3509">
              Для українців у Лондоні
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-3510">
              Ми розуміємо, як важливо мати надійного стоматолога, коли ви
              далеко від дому.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10" data-id="element-3511">
            {[{
            icon: Heart,
            title: 'Ми розуміємо ваші потреби',
            desc: 'Багато наших пацієнтів — українці, які нещодавно переїхали до Лондона. Ми знаємо, з якими труднощами ви стикаєтесь, і створюємо комфортну атмосферу.'
          }, {
            icon: Languages,
            title: 'Пояснюємо лікування українською',
            desc: "Жодного мовного бар'єра. Ми детально пояснюємо діагноз, план лікування та всі варіанти зрозумілою мовою."
          }, {
            icon: Users,
            title: 'Працюємо з новоприбулими',
            desc: 'Якщо ви нещодавно переїхали до UK і не знаєте, як працює стоматологія тут — ми допоможемо розібратися в системі та знайти найкраще рішення.'
          }, {
            icon: BookOpen,
            title: "Роз'яснюємо систему UK стоматології",
            desc: 'NHS vs приватна стоматологія, як обрати лікаря, що покриває страховка — відповімо на всі ваші запитання.'
          }].map((item, idx) => <Card key={idx} className="p-6 bg-teal-50 border-teal-100" data-id="element-3512">
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-teal-600 mb-4 shadow-sm" data-id="element-3513">
                  <item.icon className="w-5 h-5" data-id="element-3514" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-3515">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-3516">
                  {item.desc}
                </p>
              </Card>)}
          </div>

          <div className="bg-teal-900 rounded-2xl p-8 text-center max-w-4xl mx-auto" data-id="element-3517">
            <p className="text-lg text-teal-50 font-medium leading-relaxed" data-id="element-3518">
              "Dentico Clinic — це не просто клініка, а місце, де вас
              зрозуміють. Ми пишаємося тим, що стали надійним стоматологічним
              партнером для української громади в Лондоні. Запишіться на
              консультацію — і переконайтесь самі."
            </p>
          </div>
        </div>
      </section>

      {/* MID-PAGE CTA */}
      <section className="py-12 bg-teal-600" data-id="element-3519">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-3520">
          <h2 className="text-2xl lg:text-3xl font-bold text-white mb-4" data-id="element-3521">
            Готові записатись на прийом?
          </h2>
          <p className="text-teal-100 mb-6" data-id="element-3522">
            Оберіть зручний спосіб запису — онлайн, через месенджер або замовте
            зворотний дзвінок.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-3" data-id="element-3523">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-3524">
              <Button size="lg" className="gap-2 bg-white text-teal-900 hover:bg-teal-50" data-id="element-3525">
                <Calendar className="w-5 h-5" data-id="element-3526" />
                Записатись онлайн
              </Button>
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-id="element-3527">
              <Button variant="outline" size="lg" className="gap-2 border-white text-white hover:bg-white/10" data-id="element-3528">
                <MessageCircle className="w-5 h-5" data-id="element-3529" />
                WhatsApp
              </Button>
            </a>
            <Button variant="outline" size="lg" className="gap-2 border-white text-white hover:bg-white/10" onClick={() => setIsCallbackOpen(true)} data-id="element-3530">
              <Phone className="w-5 h-5" data-id="element-3531" />
              Замовити дзвінок
            </Button>
          </div>
        </div>
      </section>

      {/* 4. SERVICES */}
      <section className="py-16 bg-gray-50" data-id="element-3532">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3533">
          <div className="text-center mb-12" data-id="element-3534">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-3535">
              Наші стоматологічні послуги в Лондоні
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-3536">
              Повний спектр сучасної стоматології для всієї родини в Angel,
              Islington (EC1V).
            </p>
          </div>

          {/* Featured SEO service pages */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10" data-id="element-3537">
            {[{
            to: '/ua/implanty-london',
            title: 'Імплантація зубів',
            desc: 'Відновлення втрачених зубів за допомогою сучасних імплантів преміум-класу.',
            badge: 'Популярне'
          }, {
            to: '/ua/veneers-london',
            title: 'Вініри',
            desc: 'Керамічні та композитні вініри для ідеальної посмішки.',
            badge: 'Естетика'
          }, {
            to: '/ua/root-canal-london',
            title: 'Лікування каналів',
            desc: 'Безболісна ендодонтія під мікроскопом для збереження зуба.',
            badge: 'Лікування'
          }, {
            to: '/ua/emergency-dentist-london',
            title: 'Невідкладна допомога',
            desc: 'Терміновий прийом при гострому болю, травмі або набряку.',
            badge: 'Терміново'
          }].map((item, idx) => <Link key={idx} to={item.to} className="group block" data-id="element-3538">
                <Card className="h-full p-6 border-2 border-teal-100 hover:border-teal-400 hover:shadow-lg transition-all" data-id="element-3539">
                  <span className="inline-block text-xs font-semibold text-teal-700 bg-teal-50 px-2 py-0.5 rounded-full mb-3" data-id="element-3540">
                    {item.badge}
                  </span>
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors" data-id="element-3541">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-500 mb-4" data-id="element-3542">{item.desc}</p>
                  <div className="flex items-center text-sm font-medium text-teal-600" data-id="element-3543">
                    Детальніше <ArrowRight className="w-4 h-4 ml-1" data-id="element-3544" />
                  </div>
                </Card>
              </Link>)}
          </div>

          {/* Other services grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-3545">
            {services.map((service, idx) => <Link key={idx} to={`/ua/services/${service.id}`} className="group block" data-id="element-3546">
                <Card className="h-full p-6 hover:border-teal-200 hover:shadow-lg transition-all" data-id="element-3547">
                  <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-gray-600 mb-4 group-hover:bg-teal-100 group-hover:text-teal-600 transition-colors" data-id="element-3548">
                    <service.icon className="w-5 h-5" data-id="element-3549" />
                  </div>
                  <h3 className="font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors" data-id="element-3550">
                    {service.title}
                  </h3>
                  <p className="text-sm text-gray-500 mb-4" data-id="element-3551">{service.desc}</p>
                  <div className="flex items-center text-sm font-medium text-teal-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-3552">
                    Детальніше <ArrowRight className="w-4 h-4 ml-1" data-id="element-3553" />
                  </div>
                </Card>
              </Link>)}
          </div>
          <div className="text-center mt-10" data-id="element-3554">
            <Link to="/ua/services" data-id="element-3555">
              <Button variant="outline" size="lg" data-id="element-3556">
                Всі послуги клініки
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* 5. LOCATION */}
      <section className="py-16 bg-gray-50" data-id="element-3557">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3558">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-3559">
            <div className="grid lg:grid-cols-2" data-id="element-3560">
              <div className="p-8 lg:p-12 flex flex-col justify-center" data-id="element-3561">
                <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-3562">
                  Де знаходиться клініка
                </h2>
                <div className="space-y-6" data-id="element-3563">
                  <div className="flex items-start gap-4" data-id="element-3564">
                    <div className="p-3 bg-teal-50 rounded-lg text-teal-600 shrink-0" data-id="element-3565">
                      <MapPin className="w-6 h-6" data-id="element-3566" />
                    </div>
                    <div data-id="element-3567">
                      <h3 className="font-bold text-gray-900 mb-1" data-id="element-3568">Адреса</h3>
                      <p className="text-gray-600" data-id="element-3569">360-364 City Road</p>
                      <p className="text-gray-600" data-id="element-3570">London EC1V 2PY</p>
                      <p className="text-sm text-teal-600 mt-2 font-medium" data-id="element-3571">
                        5 хвилин від Angel Station
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4" data-id="element-3572">
                    <div className="p-3 bg-teal-50 rounded-lg text-teal-600 shrink-0" data-id="element-3573">
                      <Calendar className="w-6 h-6" data-id="element-3574" />
                    </div>
                    <div data-id="element-3575">
                      <h3 className="font-bold text-gray-900 mb-1" data-id="element-3576">
                        Години роботи
                      </h3>
                      <p className="text-gray-600" data-id="element-3577">Пн - Сб: 10:00 - 18:00</p>
                      <p className="text-gray-600" data-id="element-3578">Нд: Зачинено</p>
                    </div>
                  </div>
                </div>
                <div className="mt-8 flex flex-col sm:flex-row gap-3" data-id="element-3579">
                  <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" data-id="element-3580">
                    <Button size="lg" className="gap-2 w-full sm:w-auto" data-id="element-3581">
                      <MapPin className="w-4 h-4" data-id="element-3582" />
                      Маршрут
                    </Button>
                  </a>
                  <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-3583">
                    <Button variant="outline" size="lg" className="gap-2 w-full sm:w-auto" data-id="element-3584">
                      <Calendar className="w-4 h-4" data-id="element-3585" />
                      Записатись
                    </Button>
                  </a>
                </div>
              </div>
              <div className="h-[400px] lg:h-auto bg-gray-200 relative" data-id="element-3586">
                <iframe src={MAPS_EMBED_URL} width="100%" height="100%" style={{
                border: 0
              }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Dentico Clinic Location" className="absolute inset-0" data-id="element-3587"></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 6. FAQ SECTION - SEO CRITICAL */}
      <section className="py-16 bg-white" data-id="element-3588">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3589">
          <div className="text-center mb-10" data-id="element-3590">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-3591">
              Часті запитання
            </h2>
            <p className="text-gray-600" data-id="element-3592">
              Відповіді на популярні запити про українського стоматолога в
              Лондоні.
            </p>
          </div>

          <div className="space-y-2" data-id="element-3593">
            {faqs.map((faq, idx) => <AccordionItem key={idx} question={faq.q} answer={faq.a} isOpen={openFaqIndex === idx} onToggle={() => toggleFaq(idx)} data-id="element-3594" />)}
          </div>
        </div>
      </section>

      {/* 7. BOOKING CTA */}
      <section className="py-16 bg-teal-900" data-id="element-3595">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-3596">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-3597">
            Запишіться на прийом сьогодні
          </h2>
          <p className="text-xl text-teal-100 mb-8 max-w-2xl mx-auto" data-id="element-3598">
            Зателефонуйте, напишіть або запишіться онлайн — ми відповімо
            українською.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-3599">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-3600">
              <Button size="lg" className="w-full gap-2 bg-white text-teal-900 hover:bg-teal-50" data-id="element-3601">
                <Calendar className="w-5 h-5" data-id="element-3602" />
                Записатись онлайн
              </Button>
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-3603">
              <Button variant="outline" size="lg" className="w-full gap-2 border-teal-400 text-teal-100 hover:bg-teal-800 hover:text-white" data-id="element-3604">
                <MessageCircle className="w-5 h-5" data-id="element-3605" />
                WhatsApp
              </Button>
            </a>
            <div className="w-full sm:w-auto" data-id="element-3606">
              <Button variant="outline" size="lg" className="w-full gap-2 border-teal-400 text-teal-100 hover:bg-teal-800 hover:text-white" onClick={() => setIsCallbackOpen(true)} data-id="element-3607">
                <Phone className="w-5 h-5" data-id="element-3608" />
                Замовити дзвінок
              </Button>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}